var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { CSSTransition } from 'react-transition-group';
import { Type } from '@philips-internal/oswald-ui-constants';
import { AwesomeComponent, ComponentType, Container } from '@philips-internal/oswald-ui-core';
import { bool, eventListener, expression, node, number, oneOf, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { AbortableCloseEvent, CloseEvent } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { classNames, enumValues, isDefined, isEnumValid, isFunction } from '@philips-internal/oswald-ui-utils';
import { Link } from '../link/link.js';
import ToastAPI from './toast-api.js';
import './toast.css';
const ToastContainer = {
    acceptedTypes: [
        ComponentType.LAYOUT,
    ],
    name: '',
};
let Toast = class Toast extends Component {
    constructor() {
        super(...arguments);
        this.timeoutId = null;
        this.state = {
            open: false,
        };
        this.shouldClose = () => {
            const { onBeforeClose } = this.props;
            let close = true;
            if (isFunction(onBeforeClose)) {
                const abort = () => close = false;
                onBeforeClose(new AbortableCloseEvent({ abort }));
            }
            return close;
        };
        this.closeToast = () => {
            if (!this.shouldClose()) {
                return;
            }
            this.setState({ open: false });
            const { onClose } = this.props;
            if (isFunction(onClose)) {
                onClose(new CloseEvent());
            }
        };
    }
    componentDidMount() {
        const { initialOpen } = this.props;
        if (isDefined(initialOpen)) {
            this.setState({ open: initialOpen });
        }
    }
    render() {
        const { children, className, showCloseButton, timeOut, type, uuid, value } = this.props;
        const { open } = this.state;
        if (open && timeOut) {
            if (this.timeoutId) {
                clearTimeout(this.timeoutId);
            }
            this.timeoutId = setTimeout(this.closeToast, timeOut);
        }
        const lightTheme = type !== Type.CAUTION;
        const classes = classNames({
            'c-toast': true,
            [`c-toast--${type}`]: isEnumValid(Type, type),
            't-light': lightTheme,
            [`${className}`]: Boolean(className),
        });
        return (React.createElement(CSSTransition, { classNames: "c-toast__slide", in: open, timeout: 300, unmountOnExit: true },
            React.createElement(Container, { acceptedTypes: ToastContainer.acceptedTypes, className: classes, uuid: uuid },
                React.createElement("div", { className: "c-toast__message", "x-contrast": "bg cl" }, MessageService.translate(value)),
                React.createElement("div", { className: "c-toast__actions u-expand" }, children),
                showCloseButton ? React.createElement(Link, { className: "c-toast__close", onClick: this.closeToast }) : null)));
    }
};
Toast.propTypes = {
    children: node.notEnumerable(),
    className: string.notEnumerable(),
    initialOpen: bool,
    onBeforeClose: eventListener,
    onClose: eventListener,
    showCloseButton: bool,
    timeOut: number,
    type: oneOf(enumValues(Type)),
    uuid: string,
    value: expression,
};
Toast.defaultProps = {
    type: Type.NEUTRAL,
};
Toast = __decorate([
    AwesomeComponent({ api: ToastAPI, containers: [ToastContainer], type: ComponentType.FEEDBACK })
], Toast);
export default Toast;
//# sourceMappingURL=toast.js.map